module.exports = __webpack_public_path__ + "img/error_case_1.1a10309.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/type-setting/error_case_1.svg
// module id = 0kYS
// module chunks = 1